export const STORE_MODULE_PASSWORD = 'STORE_MODULE_PASSWORD';

export const CONDITIONS_NAMES = {
  NO_SPACES: 'NO_SPACES',
  LOWERCASE_LETTER: 'LOWERCASE_LETTER',
  CAPITAL_LETTER: 'CAPITAL_LETTER',
  ONE_DIGIT: 'ONE_DIGIT',
  MIN_LENGTH: 'MIN_LENGTH',
};
